<script>
	import "chota";
	import Nav from "./components/nav.svelte";
	import Intro from "./components/intro.svelte";
	import Middle from "./components/middle.svelte";
	import MiddleSecond from "./components/middleSecond.svelte";
	import Team from "./components/team.svelte";
	import Results from "./components/results.svelte";
	import LeanLeadership from "./components/leanLeadership.svelte";
	import LeanTools from "./components/leanTools.svelte";
	import HireLean from "./components/hireLean.svelte";
	import Contact from "./components/contact.svelte";
</script>

<svelte:head>
	<title>Simonsson & Widerberg Lean AS</title>
	<link
		href="https://fonts.googleapis.com/css2?family=Montserrat&display=swap"
		rel="stylesheet"
	/>
</svelte:head>
<body>
	<Nav />
	<Intro />
	<Middle />
	<Team />
	<Results />
	<MiddleSecond />
	<LeanLeadership />
	<LeanTools />
	<HireLean />
	<Contact />
</body>

<style>
	body {
		font-family: Montserrat;
		color: rgb(32, 32, 32);
	}
</style>
